import "./dashboard-row.scss";

import { customElement, bindable, bindingMode } from "aurelia-framework";

@customElement("dashboard-row")
export class DashboardRow {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public isLoading: boolean;
}